import { useQueries } from "@tanstack/react-query";
import React, { createContext, useContext } from "react";
import { getEntities, getSettings } from "src/api/settings";
import { useAuth } from "src/providers/AuthProvider";

const Context = createContext({
	entities: [],
	settings: null,
});

const DashboardContext = ({ children }) => {
	const { user } = useAuth();

	const [{ data: rawEntities }, { data: rawSettings }] = useQueries({
		queries: [
			{
				queryKey: ["entities"],
				queryFn: () => getEntities({ limit: 30 }),
				suspense: true,
			},
			{
				queryKey: ["settings"],
				queryFn: () => getSettings({ businessUuid: user?.business_uuid }),
				suspense: true,
			},
		],
	});

	const entities = rawEntities?.data?.data ?? [];
	const settings = rawSettings?.data;

	return <Context.Provider value={{ entities, settings }}>{children}</Context.Provider>;
};

export const useDashboardContext = () => {
	const context = useContext(Context);

	if (!context) throw new Error("Use dashboard context within provider");

	return context;
};

export default DashboardContext;
